<template>
  <div v-if="isShowDisIndex" @touchmove.stop.prevent>
    <!-- <van-popup :show="show" bind:close="onClose" z-index="130" close-on-click-overlay close-icon-position="top-right" @close="onClose" round >
      <div class="form" style="background: #221790;" >
        <i class="icon iconfont icon-guanbi" style="position: absolute; right: 0;color: #000000;" @click="onClose"></i>
        <image class="logo" @click="goLink(list)" style="display: block;" mode="widthFix" :src="list.pictureUrl" v-if="list && list.pictureUrl" />  
      </div>
    </van-popup> -->
    <!-- <div @click="onClose" style="color: #fff;background: rgba(0, 0, 0, .7);" class="disCen"><img style="width: 60px;height: 60px;" src="../../../assets/img/navBack/X.png" alt=""></div> -->

    <div class="popLayer" style="display: block"></div>
    <div style="text-align: center; display: block" class="popup_first">
      <img
        v-if="!popData.isLottery"
        class="logo"
        style="
          width: 300px;
          display: block;
          border-radius: 15px;
          height: 400px;
          position: absolute;
          left: 50%;
          top: 20%;
          margin-left: -150px;
          margin-top: -150px;
          z-index: 999;
        "
        mode="widthFix"
        src="https://oss.cmef.com.cn/cloudExhibition/imgs/202309/d60e13f9f47a4a00b7d826c9fe53ecb3.png"
      />
      <img
        v-else
        class="logo"
        style="
          width: 300px;
          display: block;
          border-radius: 15px;
          height: 400px;
          position: absolute;
          left: 50%;
          top: 20%;
          margin-left: -150px;
          margin-top: -150px;
          z-index: 999;
        "
        mode="widthFix"
        src="https://oss.cmef.com.cn/cloudExhibition/imgs/202309/c2473aea5149491aaff7e388d392309a.png"
      />
      <p v-if="popData.isLottery" class="title">
        {{ popData.companyNameShortEn ? popData.companyNameShortEn : popData.companyNameEn }}
      </p>
      <p v-else class="title"></p>
      <button
        v-if="popData.isLottery"
        @click="productClickWinning()"
        style="
          position: absolute;
          width: 35%;
          background-color: transparent;
          color: transparent;
          border-radius: 44px;
          z-index: 999;
          bottom: 65px;
          opacity: 0.1;
          height: 42px;
        "
      >
        跳转客服
      </button>
      <button
        v-else
        @click="productClick(popData.productId)"
        style="
          position: absolute;
          width: 35%;
          background-color: transparent;
          color: transparent;
          border-radius: 44px;
          z-index: 999;
          bottom: 65px;
          opacity: 0.1;
          height: 42px;
        "
      >
        查看展品
      </button>
      <img v-if="popData.isLottery" class="productBanner" :src="productLogo" alt="" />
      <img v-else class="productBanner1" :src="productLogo" alt="" />
      <p class="productName">{{ popData.productNameEn }}</p>
      <!-- rgba(0, 0, 0, 0.5) -->
      <p @click="closeSearch()" class="closeB">
        <img
          src="https://oss.cmef.com.cn/cloudExhibition/imgs/202303/5c3b8b59dc974f288ecdcf194d3bae00.png"
          alt=""
          style="width: 50px; height: 100px"
        />
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["companyName", "productName", "productLogo", "isShowDisIndex", "popData"],
  data() {
    return {
      show: false,
      list: null,
      pictureUrl: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions({
      getWeChatSkipSettleByPage: "skipSettle/getWeChatSkipSettleByPage",
      goLink: "skipSettle/goLink",
      linkToProduct: "linkTo/linkToGameProduct",
    }),

    closeSearch() {
      this.$parent.closeSearch();
    },
    async init() {
      //   let list = await this.getWeChatSkipSettleByPage(this.option);
      //   if (list && list.items && list.items[0]) {
      //     this.list = list.items[0];
      //     console.log('firstPage', list);
      //   } else {
      //     this.show = false
      //   }
      this.pictureUrl =
        "https://oss.cmef.com.cn/cloudExhibition/imgs/202309/c2473aea5149491aaff7e388d392309a.png";
    },
    productClick(productId) {
      console.log("productId",productId);
      const url = location.origin + `/pro-detailsEn/${productId}?isPop=true`;
      window.open(url, "_blank");
    //   this.$router.push(`/pro-detailsEn/${productId}?compId=${this.compId}`);
    if(option.isPop){
this.isShowDisIndex = true
     }
   
    },
    productClickWinning(productId) {
     window.open('https://www.cmef.com.cn/en/contactus?cid=4','_blank')
    },
  },
  created() {},
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.popLayer {
  height: 750%;
  background-color: #000;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  -moz-opacity: 0.4;
  opacity: 0.4;
  filter: alpha(opacity=80);
  /* 只支持IE6、7、8、9 */
}

.title {
  z-index: 9999;
  position: absolute;
  color: #d9b97e;
  top: -40px;
  text-align: center;
  width: 50%;
  font-size: 20px;
  left: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.productName {
  z-index: 9999;
  position: absolute;
  color: #ffffff;
  top: 225px;
  text-align: center;
  width: 50%;
  font-size: 16px;
  left: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.productBanner {
  z-index: 9999;
  position: relative;
  width: 190px;
  height: 150px;
  bottom: -60px;
  left: 10px;
}
.productBanner1 {
  z-index: 9999;
  position: relative;
  width: 190px;
  height: 150px;
  bottom: -60px;
  left: 10px;
}
.popup_first {
  // background-color: #FFFFFF;
  z-index: 9999999;

  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  width: 580px;
  height: 387px;
  // border-radius: 15px;
}
.showDisplay {
  display: block;
}
.unShowDisplay {
  display: none;
}

.closeB {
  bottom: 0;
  margin: auto;
  right: 0;
  position: absolute;
  left: 50%;
  top: 100%;
  margin-left: -295px;
  margin-top: -70px;
  z-index: 99;
}
</style>
